import { render } from "./RequestNotifPermission.vue?vue&type=template&id=4d1af622"
import script from "./RequestNotifPermission.vue?vue&type=script&lang=js"
export * from "./RequestNotifPermission.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__